export default "example\n\\x65\\x78\\x61\\x6d\\x70\\x6c\\x65\n\\x74\\x68\\x69\\x73\n"